module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "scrollable"
  }, [_c('h3', {
    staticClass: "section-title"
  }, [_vm._v("Рецепты")]), _vm._v(" "), _vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "recipes-wrap"
  }, [_c('div', {
    staticClass: "recipes-container"
  }, [_c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("1")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v(_vm._s(_vm.RecipeItem[5].name))]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(1)], 1)]), _vm._v(" "), _c('div', {
    staticClass: "recipes-col"
  }, [_c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(2)], 1), _vm._v(" "), _c('div', {
    staticClass: "recipes-item"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'Recipe',
        params: {
          id: _vm.index + 1
        }
      }
    }
  }), _vm._v(" "), _c('img', {
    attrs: {
      "src": "/static/images/recieps/rec1.png",
      "alt": ""
    }
  }), _vm._v(" "), _vm._m(3)], 1)])]), _vm._v(" "), _c('div', {
    staticClass: "recipe-button"
  }, [_c('router-link', {
    staticClass: "btn btn-hover",
    attrs: {
      "to": "/recipes"
    }
  }, [_c('span', [_vm._v("больше рецептов")])])], 1)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "text-container text-container-relative"
  }, [_c('h3', {
    staticClass: "text-title"
  }, [_vm._v("Мы подобрали рецепты на твой вкус:")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("3")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("2")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "recipes-info"
  }, [_c('span', {
    staticClass: "recipes-num recipes-num-round"
  }, [_vm._v("4")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-name"
  }, [_vm._v("Стейки с картофелем и спаржей на гриле")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-portions"
  }, [_vm._v("4 порции")]), _vm._v(" "), _c('span', {
    staticClass: "recipes-time"
  }, [_vm._v("35 минут")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-634e343e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/pages/RecipesTest.vue
// module id = 100
// module chunks = 0